import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import get from 'lodash.get';
import RunningGirl from '@amplify/running-girl';
import { INTERP_COLOR_MAPPER } from '../../../constants/shared/CommonInterpretationMapper';
import { RUNNING_GIRL } from '../../../constants/reading/DemoModeConstants';

const RUNNING_GIRL_CONTAINER_CSS_STRING =
    'bottom: 28%; height: calc(100% * (2 / 3)); width: 10.5%; left: 5.3%;';

const PROGRESS_BAR_CONTAINER_CSS_STRING = 'height: 30%';

const RunningGirlSection = props => {
    const { scoreObject, cutScores, ratesSection, measureName, isAvailableTitle } =
        props.runningGirlParams;
    const barColors = Object.keys(cutScores).map(cutscore => INTERP_COLOR_MAPPER[cutscore]);

    return (
        <div data-tour-step={RUNNING_GIRL} data-test-id="running-girl-section" className="col-4">
            {isAvailableTitle && (
                <div data-test-id="running-girl-title">
                    <strong>{measureName}</strong>
                </div>
            )}
            {!isEmpty(cutScores) && (
                <RunningGirl
                    actualScore={scoreObject.score}
                    cutScores={Object.values(cutScores).concat(get(scoreObject, 'maxScore', 100))}
                    barColors={barColors}
                    containsMaxScore
                    height={100}
                    width={400}
                    containerCustomStyles={RUNNING_GIRL_CONTAINER_CSS_STRING}
                    barCustomStyles={PROGRESS_BAR_CONTAINER_CSS_STRING}
                />
            )}
            {ratesSection}
        </div>
    );
};

RunningGirlSection.defaultProps = {
    runningGirlParams: {
        scoreObject: {
            score: 0,
            maxScore: 100,
            correctResponses: 0,
        },
        cutScores: {},
        ratesSection: {},
        measureName: null,
        isAvailableTitle: false,
    },
};

RunningGirlSection.propTypes = {
    runningGirlParams: PropTypes.object,
};

export default RunningGirlSection;
